module.exports = __webpack_public_path__ + "assets/img/growup3.bff46f69.jpg";